import {defineStore} from 'pinia'
import type { UserData } from '@/models/user'

export const useUserStore = defineStore({
    id: 'user',
    persist: true,
    state: () => ({
        user: {} as UserData,
        auth_token: '',
    }),
    getters: {
        userId: state => state.user.id,
        isLoggedIn: state => state.auth_token !== '',
        shortName: state => `${state.user.first_name?.slice(0, 1)}${state.user.last_name?.slice(0, 1)}`,
        userRole: state => state.user.user_role,
        isCustomer: state => state.user.user_role === 2,
        isSupplier: state => state.user.user_role === 3,
        isSupplierProductionPartner: state => (
          state.user.user_role === 3 && !!state.user.custom_event_role_only_approved_status
        ),
        isSupplierProjectManagement: state => (
            state.user.user_role === 3 && !!state.user.custom_event_role_can_approve_all_items
        ),
        isProjectManagementRole: state => (
            !!state.user.custom_event_role_can_approve_all_items
        ),
        isLinkCreatedUser: state => !!state.user.is_link_created_user,
        isAdmin: state => state.user.user_role === 0,
        isWayfindingCampaignAccess: state => state.user?.campaign_access?.wayfinding,
        isBrandingCampaignAccess: state => state.user?.campaign_access?.branding,
        isKopCampaignAccess: state => state.user?.campaign_access?.kop,
        isRetailCampaignAccess: state => state.user?.campaign_access?.retail,
        isWayfindingCampaignCreateAccess: state => state.user?.campaign_create_access?.wayfinding,
        isBrandingCampaignCreateAccess: state => state.user?.campaign_create_access?.branding,
        isKopCampaignCreateAccess: state => state.user?.campaign_create_access?.kop,
        isRetailCampaignCreateAccess: state => state.user?.campaign_create_access?.retail,
        isCrApprovalsAccess(): boolean {
            return !this.isSupplier
        },
        isCrSubtasksAccess(): boolean {
            return !this.isCustomer
        },
    },
    actions: {
        saveUser(user: UserData) {
            this.user = user
        },

        saveToken(token: string) {
            this.auth_token = token
        },

        userLogout() {
            this.auth_token = ''
            this.user = {}
            localStorage.removeItem('userAbilities')
        },
    },
})

// Define the type of the store
export type UserStore = ReturnType<typeof useUserStore>
